
import { GridType } from "./grid-type";
import { GridColumnDefinition } from "src/app/shared/kendo/grid/grid-column-definition";


export class GridDefinition {
  Id: string;
  Name: string;
  EntityName: string;
  IsReadOnly: boolean;
  GridType: GridType;
  IsDataEntryGrid: boolean;
  Columns: Array<GridColumnDefinition>;
}
